export const reviews = [
    {
        name: 'Mehar Fatma',
        image: 'https://www.perfocal.com/blog/content/images/2021/01/Perfocal_17-11-2019_TYWFAQ_100_standard-3.jpg',
        msg: 'Knowledgable and professional staff . Using Web.com helps small businesses to grow smoothy and have better transition in terms of other pricy options.',
        designation: 'Writer'
    },
    {
        name: 'Raghib Hussain',
        image: 'https://media.istockphoto.com/id/1186079153/photo/hell-stay-until-he-has-it-all-figured-out.jpg?s=612x612&w=0&k=20&c=OK2bPjppdTpV9JPMmAua9gNMQnY_PObdkzmKWFj8Pmg=',
        msg: 'Technician was very helpful, but not as knowledgeable on the website builder as I would have thought. In any case, we both were able to poke around and figure it out together.',
        designation: 'Designer'
    },
    {
        name: 'Dane Afroz',
        image: 'https://thumbs.dreamstime.com/b/street-portrait-young-caucasian-man-student-portrait-young-caucasian-man-student-325451112.jpg',
        msg: 'If you’re looking for a phenomenal dining experience, look no further than [RestaurantName]. Their menu is a culinary masterpiece, offering an incredible selection of dishes that cater to diverse tastes and preferences.',
        designation: 'Drafter'
    },
    {
        name: 'Shadab',
        image: 'https://images.ctfassets.net/lh3zuq09vnm2/yBDals8aU8RWtb0xLnPkI/19b391bda8f43e16e64d40b55561e5cd/How_tracking_user_behavior_on_your_website_can_improve_customer_experience.png',
        msg: 'We have been trying to cancel for two years. They keep billing an expired credit card. We turn off auto-renew, they turn off auto-renew, yet we keep getting billed. Support says it will be fixed and it never is. Scam company.',
        designation: 'Engineer'
    }
]